import { render, staticRenderFns } from "./LibraryWork.vue?vue&type=template&id=38731b0c&"
import script from "./LibraryWork.vue?vue&type=script&lang=js&"
export * from "./LibraryWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LibraryWork.vue"
export default component.exports